import { UserRound } from "lucide-react"

import { UserAvatar } from "./user-avatar"

interface AssignedToProps {
  userId?: string | null
  className?: string
  size?: "xs" | "sm" | "md"
}

export function AssignedTo({ userId, className = "", size = "sm" }: AssignedToProps) {
  if (!userId || userId === "") {
    return (
      <div
        className={`bg-background text-muted-foreground hover:bg-accent inline-flex min-w-0 items-center gap-1 rounded-full border pr-2 text-sm font-medium ${className}`}
      >
        <div className="bg-muted flex size-6 items-center justify-center rounded-full">
          <UserRound className="size-3.5" />
        </div>
        <span className="truncate text-sm">Add assignee</span>
      </div>
    )
  }

  return <UserAvatar userId={userId} size={size} showName variant="clickable-pill" />
}
